import React from "react"
import Angellist from "../components/svg/Angellist"
import Greenhouse from "../components/svg/Greenhouse"
import Layout from "../templates/layout"
import { graphql } from 'gatsby'
import { OutboundLink } from "gatsby-plugin-google-analytics"

export default function Jobs({ location, data }) {
  return (
    <Layout location={location} containerClassName="mx-auto max-w-6xl px-8">
      <h1 className="mt-6 md:mt-12 text-center mb-4 md:mb-12">Join us!</h1>
      <div className="">
        <p className="mb-2 md:mb-8 text-center mx-auto max-w-2xl">
          Bankjoy delivers modern banking technology, including mobile banking,
          online banking, e-statements, online account opening, online loan
          origination, and conversational AI to banks and credit unions – big
          and small.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center mt-4 mb-16">
            <div className="md:mr-12 mb-2 md:mb-0"><OutboundLink href="https://boards.greenhouse.io/bankjoy" target="_blank" aria-label="Greenhouse logo" rel="noopener "><Greenhouse width={190}/></OutboundLink></div>
            <div className=""><OutboundLink href="https://angel.co/company/bankjoy/jobs/" aria-label="Angellist logo" target="_blank" rel="noopener"><Angellist width={190}/></OutboundLink></div>
        </div>
      </div>
      <h2 className="mt-2 md:mt-28 text-center mb-4 md:mb-6 font-bold text-3xl md:text-4xl">
        Current Job Openings
      </h2>
      <div>
        {data.allGreenhouseDepartment.edges
          .filter(({ node }) => node.jobPosts.length > 0)
          .map(({ node }) => (
            <div className="px-8">
              <div className="font-light text-center md:text-4xl text-2xl mb-4 md:mb-8">
                {node.name}
              </div>
              <div className="md:mb-28 ">
                {node.jobPosts.map(({ title, location }) => (
                  <div className="mb-4 border-gray-200 border px-6 py-4 md:px-8 md:py-6 rounded-full flex flex-row items-baseline hover:border-blue transition-all">
                    <div className="text-sm md:text-lg">{title}</div><div className="ml-auto text-xs md:text-sm text-gray-500">{location.name}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
      </div>
    </Layout>
  )
}

export const query = graphql`
  {
    allGreenhouseDepartment {
      edges {
        node {
          jobPosts {
            title
            location {
              name
            }
          }
          name
        }
      }
    }
  }
`
